import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiSelectItem } from '@app/Models/multi-select-item';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/autocomplete';

@Component({
    selector: 'app-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatCheckbox, MatOption]
})
export class MultiSelectComponent {
  @Input() label: string;
  @Input() selectedItemsList = [];
  @Input() itemsList: MultiSelectItem[] = [];
  @Output() listValuesChange = new EventEmitter<string[]>();

  change(): void {
    this.listValuesChange.emit(this.selectedItemsList);
  }

  toggleSelectAllValues(): void {
    if (this.isSelectAll()) {
        this.listValuesChange.emit([]);
        return;
    }

    this.listValuesChange.emit(this.getAllOptions());
  }

  isListValuesEmpty(): boolean {
    return this.itemsList.length === 0;
  }

  isSelectAll(): boolean {
    return this.selectedItemsList.length === this.getAllOptions().length;
  }

  private getAllOptions(): string[] {
    return this.itemsList.map((submissionType) => submissionType.id);
  }
}
